import { render } from "./firm_bank_accounts.vue?vue&type=template&id=9ad287c4"
import script from "./firm_bank_accounts.vue?vue&type=script&lang=js"
export * from "./firm_bank_accounts.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__